import { Observable } from 'rxjs';
import { TpvUserAccess } from '@app/domain/models/tpv/tpv-user-access.model';

/**
 * Port de lectura del árbol de accesos TPV del usuario (empresas → unidades →
 * comercios). Alimenta el selector de comercio del dashboard.
 */
export abstract class TpvUserAccessRepository {
  abstract getAccess(): Observable<TpvUserAccess>;
}
